import { findLastIndex } from 'lodash'

export default findLastIndex;
